/**
 * Centraliza armazenamento de tokens conforme "Lembrar de mim".
 * - Lembrar ON: localStorage (persistente; refresh token 30 dias).
 * - Lembrar OFF: sessionStorage (sessão; limpa ao fechar o navegador).
 */

const KEY_REMEMBER = 'auth_remember_me';
const KEY_ACCESS = 'access_token';
const KEY_REFRESH = 'refresh_token';
const KEY_REMEMBERED_EMAIL = 'auth_remembered_email';

export function getRememberMe(): boolean {
  const v = typeof window !== 'undefined' ? localStorage.getItem(KEY_REMEMBER) : null;
  return v !== 'false';
}

export function setRememberMe(remember: boolean): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(KEY_REMEMBER, remember ? 'true' : 'false');
}

export function getRememberedEmail(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(KEY_REMEMBERED_EMAIL);
}

export function setRememberedEmail(email: string | null): void {
  if (typeof window === 'undefined') return;
  if (!email) {
    localStorage.removeItem(KEY_REMEMBERED_EMAIL);
    return;
  }
  localStorage.setItem(KEY_REMEMBERED_EMAIL, email);
}

export function getTokenStorage(): Storage {
  return getRememberMe() ? localStorage : sessionStorage;
}

export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null;
  const storage = getTokenStorage();
  return storage.getItem(KEY_ACCESS);
}

export function getRefreshToken(): string | null {
  if (typeof window === 'undefined') return null;
  const storage = getTokenStorage();
  return storage.getItem(KEY_REFRESH);
}

export function setTokens(access: string, refresh: string, rememberMe: boolean): void {
  if (typeof window === 'undefined') return;
  setRememberMe(rememberMe);
  localStorage.removeItem(KEY_ACCESS);
  localStorage.removeItem(KEY_REFRESH);
  sessionStorage.removeItem(KEY_ACCESS);
  sessionStorage.removeItem(KEY_REFRESH);
  const storage = rememberMe ? localStorage : sessionStorage;
  storage.setItem(KEY_ACCESS, access);
  storage.setItem(KEY_REFRESH, refresh);
}

export function updateTokens(access: string, refresh?: string): void {
  if (typeof window === 'undefined') return;
  const storage = getTokenStorage();
  storage.setItem(KEY_ACCESS, access);
  if (refresh) storage.setItem(KEY_REFRESH, refresh);
}

export function clearTokens(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(KEY_ACCESS);
  localStorage.removeItem(KEY_REFRESH);
  sessionStorage.removeItem(KEY_ACCESS);
  sessionStorage.removeItem(KEY_REFRESH);
  localStorage.removeItem(KEY_REMEMBER);
  localStorage.removeItem(KEY_REMEMBERED_EMAIL);
}
